import type { PtoPageTab } from "@/lib/enums";

/**
 * Who sees the PTO approval alerts and where (spec 2.3; D10). The counts come from My Team's
 * `ed-pto-pending-count`, pending requests plus cancel asks (TeamPending + TeamCancelAsks,
 * HrPending + HrCancelAsks, ViewerIsHrApprover). The badges and the Home banner read My Team's
 * view (`src/lib/team/pending.ts`: `teamNavCount`, `ptoNavCount`, `bannerFor`).
 */

export interface PendingCounts {
  isHrApprover: boolean;
  /** Pending requests and cancel asks of the viewer's direct reports they may decide. */
  team: number;
  /** HR-routed pending requests and cancel asks of others (HR approver only). */
  hr: number;
}

export function showApprovalsTab(
  me: { managesAnyone: boolean } | undefined,
  c?: PendingCounts | null,
): boolean {
  return Boolean(me?.managesAnyone || c?.isHrApprover);
}

/**
 * Which tab the PTO page shows. `?tab=approvals` is honoured only for someone who may approve; a
 * pure HR approver is known only once the counts land, so until then (or until the person
 * loads) the answer is "loading" and the page holds, rather than showing My time off and flipping.
 */
export function ptoTab(
  asked: PtoPageTab | undefined,
  me: { managesAnyone: boolean } | undefined,
  c: PendingCounts | null | undefined,
  countsLoading: boolean,
): PtoPageTab | "loading" {
  if (asked !== "approvals") return "mine";
  if (showApprovalsTab(me, c)) return "approvals";
  return !me || countsLoading ? "loading" : "mine";
}
